import React, { useState } from 'react'
import styled from '@emotion/styled'
import { Form } from 'antd'
import { StyledAlert } from 'components'
import {
	StyledPreLoginForm,
	PreLoginView,
	StyledPreLoginAlert,
	PreLoginTitle,
	PreLoginSubTitle,
	PreLoginInput,
	PreLoginButton,
	PreLoginViewFooter
} from 'views/PreLogin/styled'
import useAxios from 'axios-hooks'
import { UtesterLogo, User1stLogo } from '../Logos';

const EMAIL = 'email'

const RecoverPasswordForm = styled.div({
	marginTop: 20
})

function RecoverPassword({ form }) {
	const { getFieldDecorator } = form
	const [email, setEmail] = useState('')
	const [
		{ data: passwordRecoveryResponse, loading: passwordRecoveryLoading, error: passwordRecoveryError, response },
		submitPasswordRecovery
	] = useAxios(
		{
			url: `/account/recover-password`,
			method: 'POST'
		},
		{ manual: true }
	)

	const handleSubmit = event => {
		event.preventDefault()
		form.validateFields([EMAIL], (errors, values) => {
			const { email } = values
			setEmail(email)
			if (!errors) {
				submitPasswordRecovery({ data: {email} })
			}
		})
	}

	const errorMessage =
		passwordRecoveryError &&
		passwordRecoveryError.response &&
		passwordRecoveryError.response.data &&
		passwordRecoveryError.response.data.Errors &&
		passwordRecoveryError.response.data.Errors.join('\n')


	const successMessage = response
			&& response.status == 200
			&& `Password recovery link was sent to ${email}`

	successMessage && form.resetFields()
	
	return (
		<PreLoginView>
			<StyledPreLoginForm>
				<UtesterLogo />
				{errorMessage && (
					<StyledPreLoginAlert>
						<StyledAlert showIcon type="error" message="Error" description={errorMessage} radius={4} />
					</StyledPreLoginAlert>
				)}
				{successMessage && (
					<StyledPreLoginAlert>
						<StyledAlert showIcon type="success" message="Success" description={successMessage} radius={4} />
					</StyledPreLoginAlert>
				)}
				<PreLoginTitle>Forgot Password</PreLoginTitle>
				<PreLoginSubTitle>Enter your email address for reset link</PreLoginSubTitle>
				<RecoverPasswordForm>
					<Form onSubmit={handleSubmit} layout="vertical">
						<Form.Item label="E-MAIL ADDRESS">
							{getFieldDecorator(EMAIL, {
								validateTrigger: ['onChange', 'onBlur'],
								rules: [
									{
										required: true,
										whitespace: true,
										message: 'Email is Required'
									}
								]
							})(<PreLoginInput type="email" placeholder="EMAIL" />)}
						</Form.Item>

						<PreLoginButton size="large" type="primary" htmlType="submit" loading={passwordRecoveryLoading}>
							SEND RESET LINK
						</PreLoginButton>
					</Form>
				</RecoverPasswordForm>
				<PreLoginViewFooter>
					<a href="/sign-in">Go back to sign-in</a>
				</PreLoginViewFooter>
			</StyledPreLoginForm>
			<User1stLogo />
		</PreLoginView>
	)
}
export default Form.create({})(RecoverPassword)
